import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=c67c4806&scoped=true&"
import script from "./CarList.vue?vue&type=script&lang=js&"
export * from "./CarList.vue?vue&type=script&lang=js&"
import style0 from "./CarList.vue?vue&type=style&index=0&id=c67c4806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67c4806",
  null
  
)

export default component.exports